import type { Reducer, Store } from '@reduxjs/toolkit';
import { onAuthStateChanged } from 'firebase/auth';
import type { Persistor, PersistedState as ReduxPersistedState } from 'redux-persist';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { auth } from '../config/Firebase';

type AppPersistedState = {
	gameConfig?: {
		teamNames?: [string, string];
		[key: string]: unknown;
	};
	[key: string]: unknown;
};

const migrations = {
	// Migration to update team names to 'Blue Team'/'Red Team'
	1: function redBlueTeamNames(state: ReduxPersistedState): ReduxPersistedState {
		const appState = state as unknown as AppPersistedState | undefined;
		return (appState?.gameConfig?.teamNames)
			? {
				...state,
				gameConfig: {
					...appState.gameConfig,
					teamNames: ['Blue Team', 'Red Team'],
				},
			} as ReduxPersistedState
			: state;
	},
};

const CONFIG = {
	key: 'root',
	storage,
	whitelist: ['gameConfig', 'gamePlay', 'settings'],
	version: 1,
	migrate: createMigrate(migrations, { debug: false }),
};

export function persistedReducer(rootReducer: Reducer): Reducer {
	return persistReducer(CONFIG, rootReducer);
}

export function createPersistor(store: Store): Persistor {
	const persistor = persistStore(store);

	// Reset store when user logs out
	onAuthStateChanged(auth, (user) => {
		if (!user) {
			void persistor.purge();
		}
	});

	return persistor;
}
